import React from 'react';
import './detached_icon.css';

interface IProps {
  icon: any;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  color?: string;
}

const DetachedIcon: React.FC<IProps> = ({icon, size, color}) => {
  return (
    <div
      className={`borded-icon-large external-circle size-${size} color-${color}`}
    >
      <div className={`borded-icon-large size-${size} color-${color}`}>
        <div
          className={`borded-icon-large intern-circle size-${size} color-${color}`}
        >
          {icon}
        </div>
      </div>
    </div>
  );
};

export default DetachedIcon;



// WEBPACK FOOTER //
// ./src/shared/components/detachedIcon/DetachedIcon.tsx